import React, { CSSProperties, FC } from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
  style?: CSSProperties;
}

export const ChevronUpIcon: FC<Props> = ({ className, size = 24, color = 'currentColor', style }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path d="m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"></path>
    </svg>
  );
};
